import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua';

import './style.less';
import an from '../../static/images/guidewx/an.png';
import ios from '../../static/images/guidewx/ios.png';

class GuideWXPage extends Component {
    render(){
        return(
            <DocumentTitle title={'爱课客户端'}>
                <div className="container guidewx">
                    <div className={`img`}>
                        <img src={`${UA.iphone?ios:an}`} alt="爱课服务号"/>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default GuideWXPage;



// WEBPACK FOOTER //
// ./src/components/guideWXPage/index.jsx